import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./Portfolio.css";
import { Link45deg } from "react-bootstrap-icons";
import { motion } from "framer-motion";
import Navbar from "../../Hooks/Navbar/Navbar";
import Modal from "../../Hooks/Modal/Modal";
// import { Link } from "react-router-dom";
import usestyle from "../../Hooks/style/usestyle";
import ReactGA from "react-ga4";
const Portfolio = () => {
  const [showModal, setShowModal] = useState(false);
  const { variant } = usestyle();
  const [project, setProject] = useState(0);
  const contener = useRef();
  const handelShowModal = (project) => {
    setProject(project);
    setShowModal(true);
    contener.current.hidden = true;
  };
  const handelcloseModal = () => {
    setShowModal(false);
    contener.current.hidden = false;
  };

  const sendEvent = () => {
    ReactGA.event({
      category: "portfolio",
      action: "clicl",
      label: "portfolio",
    });
  };
  return (
    <>
      <Helmet>
        <title>Portfolio - Mohammad Nour Khattab's Projects</title>
        <meta
          name="description"
          content="Explore my portfolio of web and mobile development projects. View examples of my work in full-stack development, including React applications, mobile apps, and innovative web solutions."
        />
        <meta
          name="keywords"
          content="Web Development Portfolio, Full Stack Projects, React Applications, Mobile Development, Web Solutions, Development Projects"
        />
        <link rel="canonical" href="https://nour-it.dev/portfolio" />
      </Helmet>
      <Navbar />
      {/* <motion.div
        initial={{ y: -1500 }}
        animate={{ y: 0 }}
        exit={{ x: "100vw", transition: { duration: 0.2 } }}
        transition={{ duration: 0.2, ease: "easeInOut", type: "spring", stiffness: "100" }}
        className="portfolio page"
      > */}
      <motion.div
        variants={variant}
        initial="initial"
        animate="animate"
        exit="exit"
        // transition="transition"
        className="portfolio page"
      >
        <div className="contener" ref={contener} onClick={sendEvent}>
          <p className="span-line ">PORTFOLIO</p>
          <div className="big-header">MY WORKS</div>
          <div className="content">
            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/lazurde/main.png" alt="L'azurde E-commerce Website" />
              </div>
              <div className="details">
                <a href="https://lazurde.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("15")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/abdulwahed/main.png" alt="Abdul Wahed E-commerce" />
              </div>
              <div className="details">
                <a href="https://www.abdulwahed.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("14")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/biomedicalcomp/main.png" alt="Biomedical Components Website" />
              </div>
              <div className="details">
                <span className="disabled-link" title="Project Under Development">
                  +
                </span>
                <p onClick={() => handelShowModal("13")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/BMC/main.png" alt="BMC College Website" />
              </div>
              <div className="details">
                <a href="https://www.bmc.edu.sa/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("12")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/miran/main.png" alt="Miran Real Estate Website" />
              </div>
              <div className="details">
                <a href="https://www.miransafiny.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("11")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/alsalawat/main.png" alt="Alsalawat Mobile App" />
              </div>
              <div className="details">
                <a
                  href="https://play.google.com/store/apps/details?id=com.mbda.alsalwat"
                  title="Download from Google Play"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +
                </a>
                <p onClick={() => handelShowModal("10")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/smh/main.png" alt="SMH Law Firm Website" />
              </div>
              <div className="details">
                <a href="https://smh.sa.com" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("9")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/lau7a/main.png" alt="Lau7a Art Store" />
              </div>
              <div className="details">
                <a href="https://lau7a.vercel.app/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("8")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/husainilaw/main.png" alt="Husaini Law Office Website" />
              </div>
              <div className="details">
                <a href="https://husainilaw.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("7")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/alwan/main.png" alt="Alwan Dashboard" />
              </div>
              <div className="details">
                <a href="https://www.focal-x.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("6")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/focal/main.png" alt="Focal Dashboard" />
              </div>
              <div className="details">
                <a href="https://alwansystem.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("5")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/alard/main.png" alt="Alard Altaiba Website" />
              </div>
              <div className="details">
                <a href="https://alard-altayiba.com/" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("4")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/elforat/main.png" alt="Elforat Company Website" />
              </div>
              <div className="details">
                <a href="https://elforatfood.com/en" title="visit website" target="_blank" rel="noopener noreferrer">
                  +
                </a>
                <p onClick={() => handelShowModal("3")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/mb/main.png" alt="MB Digital Technology Website" />
              </div>
              <div className="details">
                <a
                  href="https://www.mbdigitaltechnology.com/"
                  title="visit website"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +
                </a>
                <p onClick={() => handelShowModal("2")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>

            <div className="card">
              <div className="img img-card">
                <img src="./img/portfolio/ecommerce/main.png" alt="E-commerce Training Project" />
              </div>
              <div className="details">
                <a
                  href="https://nour99988.github.io/ecomm2"
                  title="visit website"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +
                </a>
                <p onClick={() => handelShowModal("1")} title="Project Details">
                  <Link45deg />
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {showModal && <Modal project={project} closeModal={handelcloseModal} />}
    </>
  );
};

export default Portfolio;
